import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const Turnover = () => {
    document.title = "Dövriyyə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Hesabatlar", value: "/reports" },
        { name: "Dövriyyə", value: "/reports/turnover" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Dövriyyə</h2>
                    <p>
                        Ümumi məhsulların dövriyyəsi ilə bağlı hesabat əldə etmək üçün nəzərdə tutulub. Filter bölməsində axtardığınız parametrlərə uyğun olaraq{" "}
                        <mark>məhsul</mark> və ya <mark>məhsul qrupu</mark>nun dövriyyəsi, <mark>təchizatçı</mark>dan alınan məhsulların dövriyyəsi (alışı,
                        satışı) barədə və digər məlumatları əldə etmək olar. Nümunədə Hesabatlar Dövriyyə baxmaq üçün ardıcıllıq göstərilib.
                        <br />
                        Nümunədə Hesabatlar ⮞ Dövriyyə səhifəsinə baxmaq üçün ardıcıllıq göstərilib
                        <br />
                        <Button>Filter</Button> düyməsini sıxıb, lazım olan xanaları doldurub, <Button>Axtar</Button> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/reports/turnover.gif" alt="Dövriyyə" />
                </article>
            </div>
        </div>
    );
};
